"use client";
import React from 'react';
import { Typography } from '@sravni/react-design-system';
import { useAnalytics } from '@sravni/react-utils/lib/hooks';
import img from './images/IconAppleStore.svg.js';
import img$1 from './images/IconGoogleStore.svg.js';
import img$2 from './images/IconHuaweiStore.svg.js';
import img$3 from './images/IconRuStore.svg.js';

const NAMES = {
    ["APPLE_STORE" /* APP_STORES.APPLE_STORE */]: 'App Store',
    ["GOOGLE_PLAY" /* APP_STORES.GOOGLE_PLAY */]: 'Google Play',
    ["HUAWEI_APP_GALLERY" /* APP_STORES.HUAWEI_APP_GALLERY */]: 'HUAWEI AppGallery',
    ["RU_STORE" /* APP_STORES.RU_STORE */]: 'RuStore',
};
const HREFS = {
    ["APPLE_STORE" /* APP_STORES.APPLE_STORE */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/appstore/?placement=ios_footer_install',
    ["GOOGLE_PLAY" /* APP_STORES.GOOGLE_PLAY */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/googleplay/?placement=android_footer_install',
    ["HUAWEI_APP_GALLERY" /* APP_STORES.HUAWEI_APP_GALLERY */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/huaweiAppGallery/?placement=huaweiappgallery_footer_install',
    ["RU_STORE" /* APP_STORES.RU_STORE */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/rustore/?placement=rustore_footer_install',
};
const ICONS = {
    ["APPLE_STORE" /* APP_STORES.APPLE_STORE */]: img,
    ["GOOGLE_PLAY" /* APP_STORES.GOOGLE_PLAY */]: img$1,
    ["HUAWEI_APP_GALLERY" /* APP_STORES.HUAWEI_APP_GALLERY */]: img$2,
    ["RU_STORE" /* APP_STORES.RU_STORE */]: img$3,
};
const AppStore = React.forwardRef((props, ref) => {
    const { store, ...rest } = props;
    const { pushEvent } = useAnalytics();
    const handleClick = React.useCallback(() => {
        pushEvent({
            event: 'mainEvent',
            eventCategory: 'Футер',
            eventAction: 'Переход к установке приложения',
            eventLabel: `Футер|${NAMES[store]}`,
        });
    }, [pushEvent, store]);
    return (React.createElement(Typography.Link, { ...rest, ref: ref, href: HREFS[store], onClick: handleClick, target: "_blank", rel: "nofollow noopener", "data-store": NAMES[store] },
        React.createElement("img", { src: ICONS[store], alt: NAMES[store] })));
});

export { AppStore };
//# sourceMappingURL=AppStore.js.map
